import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import Articles from '../../articlesData';
import ArticleWrapper from '../../components/ArticleWrapper';
import { AudioPlayer } from '../../components/AudioProvider';
import { ExploreMoreLinks, ArticleTitleSection } from '../../components/ArticleComponents';


const Pavlov = () => {
  const navigate = useNavigate();
  const article = Articles.find((a) => a.id === 'pavlov');
  useEffect(() => {
    if (!article.visible) {
      navigate('/in-progress');
    }
  }, [navigate, article.visible]);

  return (
    <ArticleWrapper articleId="pavlov">
      <div className="min-h-screen bg-[#111112] flex flex-col w-full">
        <ArticleTitleSection
          image='/pictures/articles/pavlov/banner.JPG'
          title='Pavlov Quick Review'
          date={article.date}
          status={article.status}
        />
        {/* Content section with side-by-side layout */}
          <div className="w-full flex flex-col gap-16 px-4 bp1080:px-8 mb-16">
            <div className="w-full flex flex-col bp1080:flex-row items-center gap-8">
              <img
                src="/pictures/articles/pavlov/pic1.JPG"
                alt="Pavlov Design"
                className="w-full bp1080:w-[55vw] h-[80vh] object-cover rounded-lg shadow-lg"
              />
              <div className="text-gray-200 text-[1.15rem] text-center bp1080:text-left bp1080:ml-[3vw] bp1080:max-w-[34vw]">
                <h2 className="text-3xl font-bold mb-4">What is it?</h2>
                <p>
            Pavlov is an elegant 65% keyboard with a sharp and sleek design. Coming in 8 different colorways, it includes a hotswap pcb, 3 plates: aluminum, polycarbonate, and fr4, and various foams. It can be currently found for $99 on{' '}
            <a
              href="https://kbdfans.com/products/pavlov"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 underline hover:text-blue-300"
            >
              KBDfans
            </a>.
                </p>
              </div>
            </div>
            <div className="w-full flex flex-col bp1080:flex-row-reverse items-center gap-8">
              <img
                src="/pictures/articles/pavlov/pic2.JPG"
                alt="Pavlov Case"
                className="w-full bp1080:w-[45vw] h-[90vh] object-cover rounded-lg shadow-lg"
              />
              <div className="text-gray-200 text-[1.15rem] text-center bp1080:mr-[2vw] bp1080:text-left bp1080:max-w-[45vw]">
                <h2 className="text-3xl font-bold mb-4">Build Quality</h2>
                <p>
            The build quality and finishing are both excellent. Full aluminum top and bottom case with a brass external weight for extra heft.
                </p><br />
                <h2 className="text-3xl font-bold mb-4">Typing Experience</h2>
                <p>
            Typing can be a bit stiff depending on your configuration. In my opinion, the gasket-tadpole mount and pc plate provides the best sound and feel.
                </p>
              </div>
            </div>
            <div className="w-full flex flex-col bp1080:flex-row items-center gap-8">
              <img
                src="/pictures/articles/pavlov/pic3.JPG"
                alt="Pavlov Typing"
                className="w-full bp1080:w-[60vw] h-[60vh] object-cover rounded-lg shadow-lg"
              />
              <div className="text-gray-200 text-[1.15rem] text-center bp1080:text-left">
              <h2 className="text-3xl font-bold mb-4">Sound Profile</h2>
                <p className="mb-4">Sound profile: Overall a little thin sounding but the plentiful options it provides allow for lots of flexibility depending on switch choice. Here are some examples:</p>
                <AudioPlayer src="/audio/pavlov/pavlov_sunsetgleam_cfoam.mp3" className="w-full mt-2" />
                <p className='text-[1rem] text-center mt-[0.5vh]'>PC Plate, Gasket Mount, Hmx Sunset Gleam, No Foams</p>
                <AudioPlayer src="/audio/pavlov/pavlov_smoothie_afoam.mp3" className="w-full mt-2" />
                <p className='text-[1rem] text-center mt-[0.5vh]'>PC Plate, Gasket Mount, Gateron Smoothie, All Foams</p>
              </div>
            </div>
            <div className="w-full flex flex-col bp1080:flex-row-reverse items-center gap-8">
              <img
                src="/pictures/articles/pavlov/pic4.JPG"
                alt="Pavlov Sound Test"
                className="w-full bp1080:w-[65vw] h-[65vh] object-cover rounded-lg shadow-lg"
              />
              <div className="text-gray-200 text-[1.15rem] text-center bp1080:text-left bp1080:mr-[2vw] bp1080:max-w-[35vw]">
                <h2 className="text-3xl font-bold mb-4">Overall Thoughts</h2>
                <p>
            Overall, the Pavlov is a solid 65% keyboard with a clean design and good build quality. The sound profile is flexible, and the typing experience can be tailored to your preferences with different plate and foam combinations. At it's current price of $99, it offers great value for those looking for a 65% keyboard.
                </p>


              </div>
            </div>
          </div>
          {/* Video section */}
        <div className="w-full flex flex-col items-center justify-center mb-24">
          <h2 className="text-3xl font-bold text-white mb-4 text-center">Build & Sound Test</h2>
          <div className="w-full flex justify-center">
            <iframe
              width="900"
              height="506"
              src="https://www.youtube.com/embed/ohxkmQ0sGlY"
              title="Pavlov Build and Sound Test"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="rounded-lg shadow-lg mx-auto w-full max-w-4xl"
            ></iframe>
          </div>
        </div>
        <ExploreMoreLinks />
      </div>
    </ArticleWrapper>
  );
};

export default Pavlov;
